import CheckBoxFilter from './checkbox-filter';

export default CheckBoxFilter;
